import { validateTenantCode } from './validation';

export const LOCALSTORAGE_TENANT_CODE = 'tenantCode';

export const saveTenantCode = (tenantCode: string): void => {
  localStorage.setItem(LOCALSTORAGE_TENANT_CODE, tenantCode.toLocaleLowerCase());
};

export const getTenantCode = (): string => {
  const tenantCode = localStorage.getItem(LOCALSTORAGE_TENANT_CODE) || '';

  if (tenantCode !== '' && !validateTenantCode(tenantCode)) {
    const transformedTenantCode = tenantCode.toLocaleLowerCase().replace(' ', '');

    saveTenantCode(transformedTenantCode);
    return transformedTenantCode;
  }

  return tenantCode;
};

export const clearTenantCode = (): void => {
  localStorage.removeItem(LOCALSTORAGE_TENANT_CODE);
};
